import React, { useEffect, useState } from 'react';
import { bannerTypes, mediaTypes } from '@/constants/types';
import { contentsAPI } from '@/utils/contentsApi';
import YoutubeIframe from '@/app/components/YoutubeIframe';
import BannerImageComponent from '@/app/components/Image/BannerImageComponent';
import VideoPlayer from '@/app/components/VideoPlayer';

function HomepageSingleMediaBannerCarousel({ section }) {
  const [data, setData] = useState([]);
  const [isFirst, setIsFirst] = useState(false);
  const [isPaused, setIsPaused] = useState(false);

  const handleUserInteraction = (interaction) => {
    setIsFirst(true);
    if (isFirst) {
      setIsPaused(interaction);
    }
  };

  // youtube embed video
  const extractYouTubeId = (url) => {
    const match = url.match(
      /(?:youtube\.com\/(?:[^/]+\/[^/]+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/s]{11})/,
    );
    return match ? match[1] : null;
  };

  // youtube embed video
  const onPlayerStateChange = (event) => {
    // if (!swiperInstance) return;

    if (event.data === window.YT.PlayerState.PLAYING) {
      setIsPaused(true);
    } else if (
      event.data === window.YT.PlayerState.PAUSED ||
      event.data === window.YT.PlayerState.ENDED
    ) {
      setIsPaused(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const contentsData = {
          sectionId: section?.id,
          contentType: section?.content_type,
        };
        const response = await contentsAPI(contentsData);
        const parsedItems =
          typeof contents === 'string' ? JSON.parse(response) : response;
        const sortedItems = [...parsedItems].sort(
          (a, b) => a.priority - b.priority,
        );
        setData([...sortedItems]);
      } catch (err) {
        console.warn('Error fetching data:', err);
      }
    };

    fetchData();
  }, []);

  if (!data || data.length === 0) {
    return null;
  }

  return (
    <div className="container homepage-single-media-banner-carousel mb-[24px] lg:mb-[41px]">
      <div className="relative overflow-hidden h-[202px] lg:h-[720px] xl:h-[720px] 2xl:h-[810px] 3xl:h-[1080px] rounded-24">
        {data[0]?.type === mediaTypes.image ? (
          <BannerImageComponent
            key={data[0]?.id}
            desktopSrc={data[0]?.image?.large}
            mobileSrc={data[0]?.image?.small}
            type={bannerTypes.homepageSingleMediaBannerCarousel}
            alt={data[0]?.title?.en}
          />
        ) : null}

        {/* experimental */}
        {data[0]?.type === mediaTypes.youtubeVideo ? (
          <YoutubeIframe
            videoId={extractYouTubeId(data[0]?.video)}
            iframeData={data[0]?.video}
            playWithID
            className="w-full object-center object-cover h-[202px] lg:h-[720px] xl:h-[720px] 2xl:h-[810px] 3xl:h-[1080px]"
            onStateChange={onPlayerStateChange}
          />
        ) : null}

        {data[0]?.type === mediaTypes.video ? (
          <VideoPlayer
            videoLink={data[0]?.video}
            onUserInteraction={handleUserInteraction}
            className="w-full h-full object-cover object-center"
            smallDeviceRatio="1.27 / 1"
            largeDeviceRatio="1.27 / 1"
            height="100%"
          />
        ) : null}
      </div>
    </div>
  );
}

export default HomepageSingleMediaBannerCarousel;
